import { useState } from 'react'
import { Link } from 'react-router-dom'

const Navbar = () => {
  const [isOpen, setIsOpen] = useState(false)

  return (
    <nav className="fixed top-0 left-0 right-0 z-50 bg-black/50 backdrop-blur-xl border-b border-gray-800/50">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="flex justify-between h-16">
          {/* Logo */}
          <Link to="/" className="flex items-center">
            <div className="text-2xl font-bold bg-gradient-to-r from-green-400 to-blue-500 bg-clip-text text-transparent">
              ViralVoice AI
            </div>
          </Link>
          
          {/* Desktop Menu */}
          <div className="hidden md:flex items-center space-x-8">
            <a href="#features" className="text-gray-300 hover:text-white transition">Features</a>
            <a href="#pricing" className="text-gray-300 hover:text-white transition">Pricing</a>
            <Link to="/affiliate" className="text-gray-300 hover:text-white transition">Affiliate</Link>
            <a 
              href="#how-it-works" 
              className="px-4 py-2 text-sm text-gray-300 hover:text-white transition-colors rounded-full hover:bg-white/10"
            >
              How It Works
            </a>
            <div className="h-8 w-px bg-white/10 mx-2"></div>
            <Link 
              to="/signup" 
              className="px-4 py-2 text-sm text-gray-300 hover:text-white transition-colors rounded-full hover:bg-white/10"
            >
              Sign up
            </Link>
            <Link
              to="/dashboard"
              className="ml-2 px-6 py-2 text-sm font-semibold bg-white hover:bg-gray-100 text-black rounded-full transition-colors"
            >
              Launch App
            </Link>
          </div>

          {/* Mobile Menu Button */}
          <button 
            className="md:hidden p-2 rounded-full hover:bg-white/10 transition-colors"
            onClick={() => setIsOpen(!isOpen)}
          >
            <svg 
              className="w-6 h-6 text-gray-300" 
              fill="none" 
              stroke="currentColor" 
              viewBox="0 0 24 24"
            >
              <path 
                strokeLinecap="round" 
                strokeLinejoin="round" 
                strokeWidth={2} 
                d={isOpen ? "M6 18L18 6M6 6l12 12" : "M4 6h16M4 12h16M4 18h16"} 
              />
            </svg>
          </button>
        </div>

        {/* Mobile Menu */}
        {isOpen && (
          <div className="md:hidden py-4 space-y-2 border-t border-white/5">
            <a 
              href="#features" 
              className="block px-4 py-2 text-gray-300 hover:text-white hover:bg-white/10 rounded-lg transition-colors"
            >
              Features
            </a>
            <a 
              href="#how-it-works" 
              className="block px-4 py-2 text-gray-300 hover:text-white hover:bg-white/10 rounded-lg transition-colors"
            >
              How It Works
            </a>
            <a 
              href="#pricing" 
              className="block px-4 py-2 text-gray-300 hover:text-white hover:bg-white/10 rounded-lg transition-colors"
            >
              Pricing
            </a>
            <div className="h-px bg-white/5 my-2"></div>
            <Link 
              to="/signup" 
              className="block px-4 py-2 text-gray-300 hover:text-white hover:bg-white/10 rounded-lg transition-colors"
            >
              Sign up
            </Link>
            <Link
              to="/dashboard"
              className="block px-4 py-2 text-sm font-semibold bg-white hover:bg-gray-100 text-black rounded-lg transition-colors text-center"
            >
              Launch App
            </Link>
          </div>
        )}
      </div>
    </nav>
  )
}

export default Navbar 